<template>
  <el-form ref="form" :model="form" label-width="120px">
    <!-- 投放机型 -->
    <el-form-item label="投放机型">
      <el-input v-model="form.brand" disabled value="vivo"></el-input>
    </el-form-item>
    <el-form-item label="cookie">
      <el-input v-model="form.cookie" ></el-input>
    </el-form-item>

    <!-- 落地页类型 -->
    <el-form-item label="落地页类型">
      <el-select v-model="form.pageType">
        <el-option label="DP" value="DP"></el-option>
        <el-option label="H5" value="H5"></el-option>
      </el-select>
    </el-form-item>

    <!-- 归属渠道 -->
    <el-form-item label="归属渠道">
      <el-select
        v-model="form.clientId"
        @change="handleChannelChange"
        :loading="loading"
        filterable
        clearable
        placeholder="请选择渠道"
      >
        <el-option
          v-for="channel in channelOptions"
          :key="channel.clientId"
          :label="channel.label"
          :value="channel.clientId"
        ></el-option>
      </el-select>
    </el-form-item>

    <!-- 转换模板 -->
    <el-form-item
      v-if="showConvertTemplateSelect && convertTemplateOptions.length > 0"
      label="转换模板"
    >
      <el-select
        v-model="form.convertTemplateId"
        placeholder="请选择转换模板"
      >
        <el-option
          v-for="template in convertTemplateOptions"
          :key="template.value"
          :label="template.label"
          :value="template.value"
        ></el-option>
      </el-select>
    </el-form-item>

    <!-- 广告主 -->
    <el-form-item label="广告主">
      <el-input
        type="textarea"
        :rows="4"
        v-model="form.advertiserText"
        placeholder="每行一个广告主ID"
      ></el-input>
    </el-form-item>
    <el-form-item label="备注">
      <el-input v-model="form.memo" ></el-input>
    </el-form-item>
    <!-- 投放子平台 -->
    <el-form-item label="投放子平台">
      <el-radio-group v-model="form.subPlatform">
        <el-radio label="站内"></el-radio>
        <el-radio label="联盟"></el-radio>
      </el-radio-group>
    </el-form-item>

    <!-- 事件源类型 -->
    <el-form-item label="事件源类型">
      <el-radio-group v-model="form.srcType">
        <el-radio label="Web">网址</el-radio>
        <el-radio label="Quickapp">快应用</el-radio>
      </el-radio-group>
    </el-form-item>

    <!-- 回传事件类型 -->
    <el-form-item label="回传事件类型">
      <el-select v-model="form.eventType">
        <el-option label="加桌" :value="10"></el-option>
        <el-option label="激活" :value="0"></el-option>
      </el-select>
    </el-form-item>

    <!-- 素材落地页 -->
    <el-form-item label="素材落地页">
      <el-select v-model="form.specialPage">
        <el-option label="  " :value="0"></el-option>
        <el-option label="短剧页面" :value="12"></el-option>
        <el-option label="工具-手机清理" :value="1408"></el-option>
        <el-option label="壁纸大全" :value="1409"></el-option>
        <el-option label="运动计步" :value="1410"></el-option>
        <el-option label="字体大小" :value="1411"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="submitForm">提交</el-button>
    </el-form-item>
  </el-form>
</template>


<script>
import axios from "axios";
import XLSX from "xlsx";
export default {
  data() {
    return {
      form: {
        brand: 'vivo',
        pageType: 'DP',
        clientId: '',
        packageName: '',
        parentId: '',
        advertiserText: '',
        subPlatform: '站内',
        srcType: 'Web',
        eventType: 10,
        specialPage: 0,
        cookie:'',
        resultList:[],
        convertTemplateId: ''

      },
      businessList: [],
      channelOptions: [],
      convertTemplateOptions: [],
      showConvertTemplateSelect: false,
      loading: false
    }
  },
  created() {

  },
  watch: {
    'form.cookie': function(newVal) {
      if (newVal && this.form.pageType) {
        this.fetchBusinessList()
      }
    },
    'form.pageType': function(newVal) {
      if (newVal && this.form.cookie) {
        this.fetchBusinessList()
      }
    }
  },
  methods: {
    async fetchBusinessList() {
      // 验证必要参数
      if (!this.form.cookie || !this.form.pageType) {
        this.$message.warning('请先填写cookie和选择落地页类型')
        return
      }

      try {
        this.loading = true
        const data = {
          cookie: this.form.cookie,
          brand: 'vivo',
          pageType: this.form.pageType || 'DP'
        }
        const response = await this.$axios.post('https://control.zjwec.cn/api/vivo/group/businesss', data)

        // 响应数据直接是 businessList 数组
        let businessList = response.data
        // 兼容处理：如果 response.data 不是数组，尝试其他格式
        if (!Array.isArray(businessList)) {
          businessList = response.data.businessList || []
        }
        this.businessList = businessList

        // 映射为 channelOptions
        this.channelOptions = businessList.map(business => ({
          label: business.nickname,
          clientId: business.id.toString(),
          parentId: business.id.toString(),
          packageName: business.packageName,
          convertTemplateIds: business.convertTemplateIds || []
        }))

        if (this.channelOptions.length === 0) {
          this.$message.warning('暂无渠道数据')
        }
      } catch (error) {
        console.error('获取渠道数据失败:', error)
        this.$message.error('获取渠道数据失败: ' + error.message)
      } finally {
        this.loading = false
      }
    },
    // 精简版（推荐）
    handleChannelChange(clientId) {
      const selected = this.channelOptions.find(item => item.clientId === clientId)
      if (selected) {
        this.form.packageName = selected.packageName
        this.form.parentId = selected.parentId

        // 处理转换模板
        if (selected.convertTemplateIds && selected.convertTemplateIds.length > 0) {
          this.convertTemplateOptions = selected.convertTemplateIds.map(id => ({
            value: id,
            label: `模板 ${id}`
          }))
          this.showConvertTemplateSelect = true
          // 默认选择第一个
          this.form.convertTemplateId = this.convertTemplateOptions[0].value
        } else {
          this.convertTemplateOptions = []
          this.showConvertTemplateSelect = false
          this.form.convertTemplateId = ''
        }
      }
    },
    async submitForm() {
      const advertiserIds = this.form.advertiserText
        .split('\n')
        .filter(item => item.trim());

      // 存储所有请求结果
      const  self = this
      const results = [];
      self.resultList = []
      try {
        for (const [index, uuid] of advertiserIds.entries()) {
          console.log(`正在发送第 ${index + 1}/${advertiserIds.length} 个请求`);

          const  data = {
            cookie: this.form.cookie,
            memo: this.form.memo || "",
            pageType: this.form.pageType,
            brand: this.form.brand,
            subPlatform: this.form.subPlatform,
            clientId: this.form.clientId,
            eventType: this.form.eventType,
            uuid: uuid.trim(), // 使用当前广告主ID
            srcType: this.form.srcType,
            parentId: this.form.parentId,
            packageName: this.form.packageName,

          }
          if ( this.form.specialPage !==0){
            data.specialPage = this.form.specialPage
          }
          if (this.form.convertTemplateId) {
            data.convertTemplateId = this.form.convertTemplateId
          }


          const response = await this.$axios.post('https://control.zjwec.cn/api/vivo/qdxcj', data);

          console.log(response.data.list[0]);
          self.resultList.push(
            response.data.list[0]
          );

          console.log(`ID ${uuid} 请求成功`);
        }

        console.log('所有请求已完成', self.resultList);
        this.exportToExcel()
        this.$message.success('所有操作已完成');
      } catch (error) {
        console.error('请求失败:', error);
        this.$message.error(`请求失败: ${error.message}`);

        this.exportToExcel()
        // 返回已完成的请求结果
        return results;
      }
    },
    // 生成时间戳文件名
    generateFileName() {
      const now = new Date()
      const pad = n => n.toString().padStart(2, '0')
      return `${now.getFullYear()}${pad(now.getMonth()+1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.xlsx`
    },

    // 导出主方法
    exportToExcel() {
      const s = this
      try {
        // 1. 准备数据
        const headers = [
          '广告账号名称',
          '广告账号ID',

          '推广名称',
          'DP链接',
          'H5链接',
          '曝光监测',
          '点击监测',

          '建议出价'
        ]

        const data = s.resultList.map(item => [
          item.advertiser_name || '',
          item.advertiser_id || '',

          item.nickname || '',
          item.copyUrl || '',
          item.selfUrl || '',
          item.impreUrl	 || '',
          item.callBackUrl || '',

          item.suggestBid	 || '',
        ])

        // 2. 创建工作簿
        const workbook = XLSX.utils.book_new()
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data])

        // 3. 设置列宽（可选）
        worksheet['!cols'] = [
          { wch: 15 }, // 广告账号ID
          { wch: 20 }, // 广告账号名称
          { wch: 20 }, // 推广名称
          { wch: 40 }, // DP链接
          { wch: 40 }, // H5链接
          { wch: 40 }, // H5链接
          { wch: 40 }, // H5链接
          { wch: 40 }  // 点击监测
        ]

        // 4. 添加工作表
        XLSX.utils.book_append_sheet(workbook, worksheet, '推广数据')

        // 5. 生成文件并保存
        const wbout = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        })

        const blob = new Blob([wbout], { type: 'application/octet-stream' })
        saveAs(blob, this.generateFileName())

        this.$message.success('导出成功')
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败: ' + error.message)
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/login/qdxqdhcj.vue